import { SITE_URL } from "@/config/site";

export const BUSINESS_ID = `${SITE_URL}/#business`;
export const WARRANTY_TERMS = "Grout color sealing comes with a 15-year warranty for homeowners. It covers the color sealer, not the tile, the installation underneath or other surfaces. Commercial work is not covered by the 15-year warranty.";

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": BUSINESS_ID,
  name: "Lazona Tile Care",
  telephone: "(480) 352-0392",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3100 W Ray Rd",
    addressLocality: "Chandler",
    addressRegion: "AZ",
    postalCode: "85226",
    addressCountry: "US",
  },
  foundingDate: "2016",
  url: SITE_URL,
  areaServed: ["Chandler", "Gilbert", "Mesa", "Queen Creek", "Paradise Valley", "Scottsdale"].map(name => ({
    "@type": "City", name, containedInPlace: { "@type": "State", name: "Arizona" },
  })),
  openingHoursSpecification: [{
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    opens: "00:00", closes: "23:59",
  }],
  description: WARRANTY_TERMS,
};

/** Keep route-specific services, articles and photos, but reference one business. */
export function normalizeBusinessSchema(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(normalizeBusinessSchema);
  if (!value || typeof value !== "object") return value;
  const node = value as Record<string, unknown>;
  const types = Array.isArray(node["@type"]) ? node["@type"] : [node["@type"]];
  if (types.includes("LocalBusiness")) return { "@id": BUSINESS_ID };
  return Object.fromEntries(Object.entries(node)
    .filter(([key]) => !["aggregateRating", "reviewRating", "ratingValue", "ratingCount", "reviewCount", "bestRating", "worstRating"].includes(key))
    .map(([key, item]) => [key, normalizeBusinessSchema(item)]));
}